export default __webpack_public_path__ + "static/media/flower-7.9c27c4b7.svg";